const normName = (value) => String(value || '').trim().toLowerCase();

const sameName = (left, right) => normName(left) === normName(right);

const countryRow = (rows, country) => {
    const list = (Array.isArray(rows) ? rows : []).filter((row) => row && typeof row === 'object');
    const exact = list.find((row) => sameName(row.country_name, country));
    if (exact) return exact;
    const blob = normName(country);
    if (!blob) return undefined;
    return list.find((row) => {
        const name = normName(row.country_name);
        return name.length >= 4 && blob.includes(name);
    });
};

const reimbursementAmount = (rows, country, dutyAndTaxes) => {
    const rule = countryRow(rows, country);
    if (!rule) return { amount: 0, percent: 0, minimum: 0 };
    const percent = Number(rule.duty_tax_percent) || 0;
    const minimum = Number(rule.minimum_amount) || 0;
    const fromPercent = (Number(dutyAndTaxes) || 0) * percent / 100;
    return { amount: Math.max(fromPercent, minimum), percent, minimum };
};

const certificateAmount = (rows, country, goodsValue, chargeableKg) => {
    const rule = countryRow(rows, country);
    if (!rule) return 0;
    const goodsLimit = Number(rule.goods_value_above);
    const weightLimit = Number(rule.chargeable_weight_above);
    const charge = Number(rule.charge_amount) || 0;
    const goodsHit = Number.isFinite(goodsLimit) && Number(goodsValue) > goodsLimit;
    const weightHit = Number.isFinite(weightLimit) && Number(chargeableKg) > weightLimit;
    return goodsHit || weightHit ? charge : 0;
};

const REMOTE_RATES = {
    B: { perKg: 1.86, minimum: 100 },
    C: { perKg: 2.40, minimum: 130 },
};

const remoteAmount = (rows, country, postalCode, chargeableKg, tierRates) => {
    const code = String(postalCode || '').trim().toLowerCase();
    if (!code) return { amount: 0, tier: '' };
    const rule = (Array.isArray(rows) ? rows : []).find((row) => (
        sameName(row.country_name, country) && String(row.postal_code || '').trim().toLowerCase() === code
    ));
    if (!rule) return { amount: 0, tier: '' };
    const tierKey = String(rule.tier || '').trim().toUpperCase();
    const saved = (Array.isArray(tierRates) ? tierRates : []).find((row) => String(row.tier || '').trim().toUpperCase() === tierKey);
    const rate = saved
        ? { perKg: Number(saved.charge_amount), minimum: Number(saved.minimum_amount) || 0 }
        : REMOTE_RATES[tierKey];
    if (!saved && Array.isArray(tierRates)) return { amount: 0, tier: tierKey };
    if (!rate || !Number.isFinite(rate.perKg)) return { amount: 0, tier: tierKey };
    const fromKg = (Number(chargeableKg) || 0) * rate.perKg;
    return { amount: Math.max(fromKg, rate.minimum), tier: tierKey, perKg: rate.perKg, minimum: rate.minimum };
};

const emptyModeRules = () => ({ reimbursement: [], certificate_of_origin: [], remote_surcharge: [], remote_tiers: [] });

export {
    reimbursementAmount,
    certificateAmount,
    remoteAmount,
    emptyModeRules,
};
